import { Redirect } from 'expo-router'
import useStepsState from '@order/hooks/useStepsState'

import Step from '@order/steps/Step'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { getNextStepHref } from '@order/utils/getNextStepHref'
import useOrderValues from '@order/hooks/values/useOrderValues'
import { useMemo } from 'react'
import { getFlow } from '@order/utils/getFlow'
import useFlowName from '@order/hooks/useFlowName'

const StepScreen = () => {
  const config = useRemoteConfig()
  const { states, orderItemId, stepId } = useStepsState()
  const { values, refraction } = useOrderValues({ states })
  const flowName = useFlowName()

  const flow = useMemo(() => getFlow(config, flowName), [config, flowName])

  const initialStepId = flow.stepModes[0]?.initialStep
  if (config && !states && stepId !== `${initialStepId}`) {
    const href = getNextStepHref({
      config,
      orderItemId,
      stepId: initialStepId ?? null,
      states: {},
      values,
      refraction,
      bundleType: 'base',
      endPath: undefined,
    })

    return <Redirect href={href} />
  }

  return <Step />
}

export default function StepPage() {
  return <StepScreen />
}
